import { render, staticRenderFns } from "./ComprasContainer.vue?vue&type=template&id=6894219b&scoped=true"
import script from "./ComprasContainer.vue?vue&type=script&lang=js"
export * from "./ComprasContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6894219b",
  null
  
)

export default component.exports